import { Button, StandardDialog } from '@roc/ui';
import { Document } from '@roc/feature-types';
import CreateClosingConditions from './createClosingCondition';
import { DocumentStore } from '@roc/feature-documents';
import { CreateClosingConditionStore } from 'libs/feature-documents/src/documents/stores/documentForms/closingCondition/createClosingConditionStore';

type CreateClosingConditionDialogProps = {
  store: CreateClosingConditionStore;
  open: boolean;
  taskId: number;
  onClose: () => void;
  onSuccess: () => void;
};

export const CreateClosingConditionDialog = ({
  store,
  open,
  taskId,
  onClose,
  onSuccess
}: CreateClosingConditionDialogProps) => {

  const onSubmit = async () => {
    store.submit(taskId, onSuccess);
  };

  return (
    <StandardDialog
      open={open}
      handleClose={onClose}
      title="Create Closing Condition"
      dialogContent={<CreateClosingConditions store={store} />}
      maxWidth="md"
      dialogActions={
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Close
          </Button>
          <Button
            onClick={onSubmit}
            color="primary"
            variant="contained"
            testId="save"
            disabled={false}
          >
            Save
          </Button>
        </>
      }
    />
  );
};

export default CreateClosingConditionDialog;
